import React from "react";
import ReactDOM from "react-dom/client";
import App, { ADMIN_PATH } from "./App";
import "./govbr";
import keycloak, { initKeycloak } from "./shared/keycloak";

const root = ReactDOM.createRoot(document.getElementById("root"));

const renderApp = () => {
  root.render(
    <React.StrictMode>
      <App keycloak={keycloak} />
    </React.StrictMode>
  );
};

const renderBootstrapError = (error) => {
  const message = error?.message || "Falha ao inicializar a autenticacao.";

  root.render(
    <React.StrictMode>
      <main
        style={{
          fontFamily: "Rawline, Arial, sans-serif",
          padding: "32px",
          maxWidth: "960px",
          margin: "0 auto"
        }}
      >
        <h1 style={{ fontSize: "28px", marginBottom: "16px" }}>
          Falha ao iniciar o sistema
        </h1>
        <p style={{ marginBottom: "12px" }}>
          O frontend carregou, mas a autenticacao nao foi concluida.
        </p>
        <pre
          style={{
            whiteSpace: "pre-wrap",
            background: "#f3f3f3",
            padding: "16px",
            borderRadius: "4px"
          }}
        >
          {message}
        </pre>
      </main>
    </React.StrictMode>
  );
};

const currentPath = window.location.pathname.replace(/\/+$/, "");
const authenticationRequiredForPage =
  currentPath === ADMIN_PATH || currentPath.startsWith(`${ADMIN_PATH}/`);

initKeycloak({ initialize: authenticationRequiredForPage })
  .then(() => renderApp())
  .catch((error) => {
    console.log("[KEYCLOAK ERROR]:", error);
    renderBootstrapError(error);
  });
